import { br } from './br';
import { en } from './en';
import { la } from './la';

interface LanguageOptions {
  [key: string]: string;
}

const dictionaryList = { en, br, la };

const languageOptions = {
  en: 'en-US',
  br: 'pt-BR',
  la: 'es-ES',
} as LanguageOptions;

export { dictionaryList, languageOptions };
